import React, { useEffect, useRef, useState } from 'react'
import { useCustomRoomContext } from '../CustomRoomContext'

export default function ProfileHeader() {
  const [isOpen, setIsOpen] = useState(false)
  const modalRef = useRef<HTMLDivElement>(null)
  const { productDetails, viewProfileOpen, setViewProfileOpen } = useCustomRoomContext()

  const handleToggleModal = () => {
    setIsOpen((prev) => !prev)
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  if (!productDetails) return null

  return (
    <div className="absolute top-2 left-2 z-50">
      {/* Header */}
      <div className="flex items-start gap-4 p-1 cursor-pointer" onClick={handleToggleModal}>
        {/* Profile Picture */}
        {productDetails.hostImage && (
          <img
            src={productDetails.hostImage}
            alt={productDetails.hostName}
            className="w-10 h-10 rounded-full object-cover"
          />
        )}

        {/* Username and Rating */}
        <div className="flex flex-col justify-center">
          <p className="text-sm font-semibold">{productDetails.hostName}</p>
          <div className="flex items-center text-yellow-500">
            <span className="text-sm">⭐</span>
            <span className="ml-1 text-sm text-gray-600">(4.5)</span>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isOpen && (
        <div
          ref={modalRef}
          className="absolute left-4 top-full mt-2 w-64 bg-white text-black rounded-lg shadow-lg border border-gray-400 z-10 p-4"
        >
          {/* Options */}
          <div className="space-y-2">
            <button
              onClick={() => setViewProfileOpen(!viewProfileOpen)}
              className="flex justify-between items-center p-3 w-full text-sm hover:bg-gray-200"
            >
              <span className="flex items-center gap-2">👤 View Profile</span>
              <span>{'>'}</span>
            </button>
            <button
              onClick={() => console.log('Message clicked')}
              className="flex justify-between items-center p-3 w-full text-sm hover:bg-gray-200"
            >
              <span className="flex items-center gap-2">💬 Message</span>
              <span>{'>'}</span>
            </button>
            <button
              onClick={() => console.log('Block clicked')}
              className="flex justify-between items-center p-3 w-full text-sm hover:bg-gray-200"
            >
              <span className="flex items-center gap-2">🚫 Block</span>
              <span>{'>'}</span>
            </button>
            <hr className="border-gray-300" />
            <button
              onClick={() => console.log('Report clicked')}
              className="flex justify-between items-center p-3 w-full text-sm hover:bg-gray-200"
            >
              <span className="flex items-center gap-2">⚠️ Report</span>
              <span>{'>'}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
